import React from 'react';
import logo from './logo.svg';
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';
import ToDoList from './components/todo'

function App() {
  return (
    <div>
      <ToDoList />
    </div>
  );
}

export default App;
